export class UserInteractionHandlerV2Proxy {
    constructor(action) {
        this.action = action;
    }
    getHref(params, urlParams) {
        return this.action.getHref
            ? this.action.getHref(params, urlParams || new URLSearchParams())
            : undefined;
    }
    get href() {
        return this.action.getHref
            ? this.action.getHref(undefined, new URLSearchParams())
            : undefined;
    }
    get enabled() {
        return this.action.enabled;
    }
    set enabled(value) {
        this.action.enabled = value;
    }
    onActivate(params, urlParams) {
        this.action.onActivate(params || undefined, urlParams || new URLSearchParams());
    }
    subscribe(listener) {
        this.action.subscribe(this, listener);
    }
    unsubscribe() {
        this.action.unsubscribe(this);
    }
}
//# sourceMappingURL=user-interaction-handler-v2.js.map